import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[disableControl]'
})
export class DisableControlDirective {

  @Input() set disableControl( condition : boolean ) {
    setTimeout(() => {
        const action = condition ? 'disable' : 'enable';
        this.ngControl.control!![action]();
    }, 0);
  }

  constructor(private ngControl: NgControl) {}

}